(function () {
  'use strict';

  refreshCartCount();

  /* ---------- Mobile nav toggle ---------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      siteNav.classList.toggle('site-nav--open');
      if (siteNav.classList.contains('site-nav--open')) {
        siteNav.style.display = 'block';
      } else {
        siteNav.style.display = '';
      }
    });
  }

  /* ---------- Search panel toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchClose = document.querySelector('[data-search-close]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.hidden = !searchPanel.hidden;
      if (!searchPanel.hidden) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', function () {
      searchPanel.hidden = true;
    });
  }

  /* ---------- Cart count (badge only, no drawer) ---------- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- AJAX add to cart (product forms + cards) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('button[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
        form.submit();
      });
  });

  /* ---------- Quantity selectors (product page + cart page) ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-quantity-plus]')) {
      var wrapPlus = e.target.closest('.quantity-selector');
      var inputPlus = wrapPlus && wrapPlus.querySelector('input[type="number"]');
      if (inputPlus) inputPlus.value = (parseInt(inputPlus.value, 10) || 1) + 1;
    }
    if (e.target.matches('[data-quantity-minus]')) {
      var wrapMinus = e.target.closest('.quantity-selector');
      var inputMinus = wrapMinus && wrapMinus.querySelector('input[type="number"]');
      if (inputMinus) {
        var newVal = (parseInt(inputMinus.value, 10) || 1) - 1;
        inputMinus.value = newVal < 0 ? 0 : newVal;
      }
    }
  });

  /* ---------- Product page: variant select + thumbnail swap ---------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var thumbs = document.querySelectorAll('.product-detail__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = document.getElementById('ProductMainImage');
        if (mainImg) mainImg.src = thumb.getAttribute('data-image-url');
      });
    });
  }
})();
